export const CUSTOMERS_ICON = 'mdi-domain'
export const CUSTOMER_ICON = 'mdi-briefcase-account'
export const CONTACT_ICON = 'mdi-card-account-mail'
export const CONTRACT_ICON = 'mdi-file-document-edit'
export const CANCELLATION_ICON = 'mdi-cancel'
export const PRODUCTS_ICON = 'mdi-toolbox'
export const PRODUCT_INVENTORY_ICON = 'mdi-shopping-search'
export const STAFF_MEMBERS_ICON = 'mdi-account-group'
export const STAFF_MEMBER_ICON = 'mdi-account-cog'
export const SIPCENTRIC_ICON = 'mdi-phone-voip'
export const HELP_ICON = 'mdi-help-circle-outline'
export const SEARCH_ITEM_ICON = 'mdi-file-search'
export const INVOICE_ICON = 'mdi-file-document-multiple'
export const SMS_ICON = 'mdi-message-processing'
export const RESERVATION_ICON = 'mdi-phone-classic'
export const RESERVATION_IMPORT_ICON = 'mdi-phone-plus'
